/* eslint-disable react/prop-types */
import React, { useEffect, useReducer, useState } from 'react';
import { Empty, Row, Col, Space, Table, Spin,  message  , Typography , Popover, Tooltip, DatePicker, Tabs, Modal, Select, Tag  } from 'antd';
import { Content } from 'antd/es/layout/layout';
import {   CarryOutOutlined, DownloadOutlined, SnippetsOutlined } from '@ant-design/icons';
import { TASK_LIST, TASK_LIST_SUCCESS, TASK_LIST_ERROR, TASK_LIST_DETAILS, TASK_LIST_DETAILS_ERROR, TASK_LIST_DETAILS_SUCCESS, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR } from './constants';


import { useAuth } from '../../Context';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AllocationReducer from './reducer';
import dayjs from 'dayjs';
import TabPane from 'antd/es/tabs/TabPane';
import Title from 'antd/es/typography/Title';
import moment from 'moment';


export default function TaskList() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {tasks : [],users_data:[], details: null, pending: false, error: false , pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(AllocationReducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;

	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const { RangePicker } = DatePicker;
	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const [startDate, setStartDate] = useState(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	const navigate = useNavigate();
	const [openAttachmentModal, setShowAttachmentsModal] = useState(false);
	const [user, setUser] = useState(null);

	useAuth();

	let image_attachements = [];
	let video_attachements =[];
	let audio_attachements =[];



	const columns = [

		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
            
		},
		{
			title: langdata && langdata.Username ? langdata.Username : 'User name',
			dataIndex: 'userName',
			key: 'userName',
            
		},
		{
			title: langdata && langdata.AssignDate ? langdata.AssignDate : 'Assign Date',
			dataIndex: 'assignedDate',
			key: 'assignedDate',
            
		},
		{
			title: langdata && langdata.Description ? langdata.Description :'Description',
			dataIndex: 'description',
			key: 'description',
			render: (text) => (
				<Popover title={langdata && langdata.Description ? langdata.Description :'Description'} content={text} trigger="hover">
					<Typography.Paragraph
						ellipsis={
							{
								rows: 2,
								expandable: false,
								symbol: ''
							}
						}
					>
						{text}
					</Typography.Paragraph>
				</Popover>
			)
            
		},
		{
			title: langdata&&langdata.Remark?langdata.Remark:'Remark',
			dataIndex: 'remarks',
			key: 'remarks',
            
		},
		{
			title: `${langdata&&langdata.Status ? langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',
		
			render: (_, { status }) => (
				<>
					<Tag color={status === 'New' ?'red' :'green'} >
						{status === 'New' ? langdata && langdata.New ? langdata.New : 'New' : langdata && langdata.Completed ? langdata.Completed : 'Completed'}
					</Tag>
				</>
			),
		},
		{
			title: langdata&&langdata.EndDate?langdata.EndDate:'End Date',
			dataIndex: 'endDate',
			key: 'endDate',
            
		},


		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.Attachments ? langdata.Attachments:'Attachments'} disabled={record.attachmentUrls.length <= 0} onClick={record.attachmentUrls.length > 0 ? openShowAttachments : null} ><SnippetsOutlined/></a>
				</Space>	
			)
		}
	];

    
    

	data?.details?.attachmentUrls? data.details.attachmentUrls.map((item)=>{

		const lower = item.toLowerCase().trim();
		if (lower.endsWith('.jpeg') || lower.endsWith('.jpg') || lower.endsWith('.png') || lower.endsWith('.svg') || lower.endsWith(' ')) {
			image_attachements.push(item);
		} else if (lower.endsWith('.mp3') || lower.endsWith('.wav') || lower.endsWith('.aac')|| lower.endsWith('.mpga')) {
			audio_attachements.push(item);
		} else if (lower.endsWith('.mp4') || lower.endsWith('.mov') || lower.endsWith('.avi') || lower.endsWith('.3gp') || lower.endsWith('.mkv') || lower.endsWith('.flv')) {
			video_attachements.push(item);
		}

	}):null;


	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
	},[authtoken]);

	useEffect(() => {
		// if(featuresModule.speedClassificationEnabled == false) {
		// 	navigate('/dashboard');
		// }
        
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4015);
	}, []);

	useEffect(() => {
		dispatch( { type: TASK_LIST });
		usersList();
		loadTasklist(1);

	}, [startDate, endDate,user]);

	const loadTasklist = (pagination) => {

		let _pagination = { };
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;

		let userParams = '';
		if(user){
			userParams =`&$and[0][userId]=${user}`;
		}
		else{
			userParams = '';
		}
        
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/tasklist-list?$sort[id]=-1&$limit=${_pagination.limit}&$skip=${_pagination.skip}&assignedDate[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&assignedDate[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}&pipelineId=${pipelineId ? parseInt(pipelineId) : null}${userParams}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {

                
				if (response.status === 200) {
					dispatch({type:TASK_LIST_SUCCESS, page:pagination.current, pageSize : pagination.pageSize , payload: response.data});
				}
                
			})
			.catch((error) => {
				dispatch({type:TASK_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);

			}else{
				
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);

			}
		} else {
			console.log('Clear');
		}
	};

	const closeShowAttachments = () => {
		setShowAttachmentsModal(false);
		
	};

	const openShowAttachments = () => {
		
		setShowAttachmentsModal(true);

	};
    
	const handleDownload = (imageUrl) => {
		fetch(imageUrl)
			.then(response => response.blob())
			.then(blob => {
			// Extract filename from URL
				const filename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch(error => console.error('Error downloading image:', error));
	};

	const loadtasklistdetails = ((record) => {
    
		dispatch( { type: TASK_LIST_DETAILS });
        
		if (!record) {
			dispatch({ type: TASK_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: TASK_LIST_DETAILS_SUCCESS, payload: record });
    
		}
    
	});
	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	let users=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];

	data.users_data && data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});

	const handleSetUser = (e) =>{
		setUser(e);
	};

	const usersList = () => {

		dispatch({ type : USERS_LIST});

		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation-list?&isDeleted=false&usertypeId[$in][]=4&usertypeId[$in][]=7&usertypeId[$in][]=13`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
      
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : USERS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : USERS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};

	
	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};

	const getDateWithTime = (date, time) => {
		if (!time) return date;
		const [hour, minute, second] = time.split(':').map(Number);
		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};

	return (
        

		<>
			<Content>

				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
					justify={'space-between'}
				>
					<Col>
						<Row>
						
							<Space>
								<CarryOutOutlined style={{fontSize:'30px'}} />
								
							</Space>
						
							<Space>&nbsp;&nbsp;</Space>
											
											
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.Task?langdata.Task:'Task'}</Title>
						</Row>

					</Col>
					
					<Col style ={{justifyContent:'right', display:'flex'}} span={14} >
						<Row>
							<Col span={24}>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.FilterbyUser ? langdata.FilterbyUser :'Filter by User'}>
									
										<Space>
											<Select Item
												style={{ minWidth: '200px', margin:'5px'}}
												showSearch
												filterOption={filterOption}
												placeholder={langdata && langdata.SelectUsers ? langdata.SelectUsers :'Select Users'}
												optionFilterProp="children"
												// onChange={onChange}
												// onSearch={onSearch}
												// filterOption={filterOption}
												defaultValue={null}
												options={users}
												onSelect={handleSetUser}
									
											/>  
										</Space>
									</Tooltip>  
								</Space>
								<Space>
										
									<Tooltip title={langdata?.Selectdate || 'Select date'}>
										<RangePicker
											onChange={onRangeChange}
											disabledDate={disabledDate}
											allowClear={false}
											showTime
											format={`${settingsdateformat} ${settingstimeformat}`}
											defaultValue={[
												getDateWithTime(dayjs().subtract(30, 'day'), customstart),
												getDateWithTime(dayjs(), customend)
											]}
										/>
									</Tooltip>
								</Space>
							</Col>
						</Row>
					</Col>
					{/* </Space> */}
				</Row>
                    
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data.tasks && data.tasks.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data.tasks} 
								pagination = { data.tasks.length > 0 ? data.pagination : 0 }
								onChange={loadTasklist}
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadtasklistdetails(record);
                                                
										}
									};
								}}
                                    
							/>
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>
			</Content>

			<Modal
				title={langdata && langdata.Attachments ? langdata.Attachments:'Attachments'}
				centered
				destroyOnClose={true}
				open={openAttachmentModal}
				onOk={{closeShowAttachments}}
				onCancel={closeShowAttachments}
				footer={[
				]}
				width={540}>
				<div  style={{ paddingTop: '20px',height:'400px',overflowY:'scroll' }}>
            
					<>
						<Tabs defaultActiveKey='1' style={{marginBottom:'10px'}}>
							<TabPane tab={langdata && langdata.Image ? langdata.Image : 'Image'} key='1'  >
            
								{image_attachements && image_attachements.length>0 ?
            
									image_attachements.map((item,index)=>(
            
										<div key={index}>
											<img  style={{width:'100%', height:'360px'}} src={item.trim()} alt='image' />
            
											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'5px',marginBottom:'20px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
                                                                            
            
            
										</div>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								}
            
							</TabPane>
            
							<TabPane tab={langdata && langdata.Audio ? langdata.Audio : 'Audio'} key='2'>
                                            
								{audio_attachements && audio_attachements.length>0 ?
                                            
									audio_attachements.map((item,index)=>(
										<>
											<audio style={{width:'100%'}}  key={index} controls>
												<source src={item.trim()} />
                                            
                                            
                                            
											</audio>
                                            
                                            
											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'10px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
                                                                                                            
                                            
                                            
										</>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                            
								}
                                            
							</TabPane>
							<TabPane tab={langdata && langdata.Video ? langdata.Video : 'Video'} key='3'>
                                            
								{video_attachements && video_attachements.length>0 ?
                                            
									video_attachements.map((item,index)=>(
										<>
											<video key={index} controls style={{width:'100%'}}>
												<source src={item.trim()} />
                                            
											</video>
                                            
											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'10px', marginBottom:'10px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
                                                                                                            
										</>
                                                                                                        
									)):
									<Empty  image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                            
								}       
							</TabPane>                              
						</Tabs>
					</>
				</div>
			</Modal>
			<Spin fullscreen spinning={data.pending} />
		</>    
	);

    
}